export default __webpack_public_path__ + "static/knowledge_sharing-d4289f08073597e5a202a1bdbde2efad.svg";